import { CloneTenantRequestSchema, CloneTenantResponseSchema } from './clone-tenant.schema';
/**
 * Clone Tenant Endpoint Contract
 * Duplicates an entire tenant — creates a new, independent tenant containing a
 * verbatim copy of the source tenant's database. Restricted to super-admins.
 *
 * The source tenant id is the `:tenantId` path param; the body carries the new
 * tenant's identity.
 *
 * Accepted, not completed: 202 means the tenant row and its clone job exist and
 * the copy is running detached. Everything that can be judged synchronously
 * (source exists, slug free, body valid) still answers 4xx before the job is
 * created, so a rejected clone never leaves a job behind.
 */ export const cloneTenantContract = {
    method: 'POST',
    path: '/api/v2/tenants/:tenantId/clone',
    description: "Start cloning a tenant, copying the source's data into a new tenant",
    requestSchema: CloneTenantRequestSchema,
    responseSchema: CloneTenantResponseSchema,
    statusCodes: {
        success: 202,
        errors: {
            400: 'Invalid request body or validation error (includes a slug already in use)',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'Source tenant not found'
        }
    }
};

//# sourceMappingURL=clone-tenant.contract.js.map